var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 100,
    height: 100,
    rx: 30,
    fill: "#47B638"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.625 31.4375H26.375C24.512 31.4375 23 32.9495 23 34.8125V36.7329L50 48.1674L77 36.7295V34.8125C77 32.9495 75.488 31.4375 73.625 31.4375Z",
    fill: "#47B638"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6581 51.5526C50.4489 51.6437 50.2227 51.6876 50 51.6876C49.7773 51.6876 49.5511 51.6437 49.3419 51.5526L23 40.3982V65.1876C23 67.0506 24.512 68.5626 26.375 68.5626H73.625C75.488 68.5626 77 67.0506 77 65.1876V40.3982L50.6581 51.5526Z",
    fill: "#47B638"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.092a0a93191bee11826fd8bce174815a.svg";
export { ForwardRef as ReactComponent };